/*
 * @Author: 陈力恒
 * @Date: 2022-08-29 15:25:59
 * @LastEditors: 赵泽文
 * @LastEditTime: 2024-05-23 17:31:46
 * @Description: file content
 */
import { Spin } from '@lemon-fe/kits';

const PageLoading = () => {
  return (
    <div
      style={{
        height: '80vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default PageLoading;
